export default __webpack_public_path__ + "static/InterDisplay-Bold-523a43d73591d6b12190c04fea6eadd1.woff";